import { Accordion, AccordionDetails, AccordionSummary, Box, LinearProgress, Typography } from '@mui/material'
import React from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DoneIcon from '@mui/icons-material/Done';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CircleIcon from '@mui/icons-material/Circle';

function ProgressCard({ image, sx, cardTitle = "", timeline = [], totalProgress = 0, currentProgress = 0, defaultExpanded = false }) {
  return (
    <Box display={"flex"} flexDirection={"row"} gap={"3rem"} sx={[{ ...sx }]}>
      <Box width={"10rem"} height={"10rem"} className={"imageWrapper"}>
        {(typeof image === "string") ?
          <img src={image} alt="" style={{ width: "100%", height: "100%" }} className={"image"} />
          :
          { image }
        }
      </Box>
      <Box display={"flex"} flexDirection={"column"} gap={"1rem"} flex={1}>
        <Typography fontFamily={"Roboto-Regular"} color={"#202124"} fontSize={"1.8rem"} className={"cardTitle"}>{cardTitle}</Typography>

        {totalProgress > 0 &&
          <Box display={"flex"} flexDirection={"row"} gap={"1rem"}>
            <Box flex={1}><LinearProgress variant="determinate" sx={{ ...progress_sx }} value={(currentProgress / totalProgress) * 100} /></Box>
            <Typography fontFamily={"Roboto-Regular"} color={"#5F6368"} fontSize={"1.2rem"}>{currentProgress} out of {totalProgress} completed</Typography>
          </Box>
        }
        {timeline.length > 0 &&
          <Box>
            <Accordion sx={[accordion_sx]} defaultExpanded={defaultExpanded}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon style={{ width: '2rem', height: '2rem' }} />}
              >
                <Typography fontFamily={"Roboto-Regular"} color={"#667085"} fontSize={"1.4rem"}>Hide tasks</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box>
                  <Timeline>

                    {(timeline.length > 0) && timeline.map((timelineItem, timelineIndex) => (
                      <TimelineItem key={`TimelineItem_${timelineIndex}`}>
                        <TimelineSeparator>
                          <TimelineDot color={timelineItem.isSelected ? `primary` : "grey"}>
                            {timelineItem.isCompleted ?
                              <DoneIcon />
                              :
                              <CircleIcon color={timelineItem.isSelected ? `primary` : "grey"} />
                            }
                          </TimelineDot>
                          {(timelineIndex !== timeline.length - 1) && <TimelineConnector />}
                        </TimelineSeparator>
                        <TimelineContent>
                          <Typography fontFamily={"Roboto-Regular"} color={timelineItem.isSelected ? `primary` : "#667085"} fontSize={"1.4rem"} style={{ textDecoration: timelineItem.isCompleted ? 'line-through' : "none" }}>{timelineItem.text}</Typography>
                        </TimelineContent>
                      </TimelineItem>
                    ))}


                  </Timeline>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Box>
        }

      </Box>
    </Box>
  )
}

export default ProgressCard;

const progress_sx = {
  height: "10px",
  borderRadius: '5px',
  backgroundColor: "#EAECF0",
  '& .MuiLinearProgress-bar': {
    // backgroundColor: "#6941c6",
  }
}

const accordion_sx = {
  width: 'fit-content',
  boxShadow: 'none',
  " .MuiAccordionDetails-root": {
    padding: "0"
  },
  [`& .MuiTimelineItem-root:before`]: {
    flex: 0,
    padding: 0,
  },
  ".MuiButtonBase-root": {
    minHeight: 'unset !important'
  },
  " .MuiAccordionSummary-content": {
    margin: "0 !important",
    padding: "0 !important",
  },
  ".MuiTimelineItem-root": {
    minHeight: '50px !important'
  },
  ".MuiTimelineDot-root": {
    margin: '6.5px 0',
    padding: '0px'
  }
}